export default __webpack_public_path__ + "static/144-c98a4911997ecd238ef71251d3c95481.gif";